<div class="d-flex align-items-center h-100">
  <div class="container-md mt-2 mb-5">
    <app-nav-prev-button></app-nav-prev-button>
    <div class="card mt-2">
      <div class="card-body">
        <div [innerHTML]="'legal_pages.legal_notice' | translate"></div>
      </div>
    </div>
  </div>
</div>
